const stringMatch = (s1, s2) => {
  return s1.toLocaleLowerCase().includes(s2.toLocaleLowerCase())
}

const isUUID = (value) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  return uuidRegex.test(value)
}

export const arraySearch = (
  arr,
  keyword,
  { searchUUID = false, searchPrivateFields = false, fieldsToSearch = [] } = {
    searchUUID: false,
    searchPrivateFields: false,
    fieldsToSearch: []
  }
) => {
  return arr.filter((item) => {
    for (const key in item) {
      if (fieldsToSearch.length > 0 && !fieldsToSearch.includes(key)) {
        continue
      }
      if (!searchPrivateFields && key.startsWith('_')) {
        continue
      }
      if (!searchUUID && isUUID(item[key])) {
        continue
      }
      if (typeof item[key] === 'string' && stringMatch(item[key], keyword)) {
        return true
      }
    }
    return false
  })
}

// user data is comming as array of object inside that object , associtated user  contains the  data of user
export const arraySearchForUser = (arr, keyword) => {
  return arr.filter((item) => {
    for (const key in item.associated_user) {
      if (typeof item.associated_user[key] === 'string' && stringMatch(item.associated_user[key], keyword)) {
        return true
      }
    }
    return false
  })
}
export const isUUIDs = (value) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  return uuidRegex.test(value)
}

// function to sort array of objects
// Pass which field to sort. Optionally the order to sort and type of field
export function sortList (list, { field, order = 'asc', type = 'string' }) {
  const isAsc = order === 'asc'

  return [...list].sort((a, b) => {
    const aValue = a?.[field]
    const bValue = b?.[field]

    // Handle null/undefined
    if (aValue == null && bValue == null) return 0
    if (aValue == null) return 1
    if (bValue == null) return -1

    let result

    if (type === 'date') {
      result = new Date(aValue) - new Date(bValue)
    } else if (type === 'number') {
      result = Number(aValue) - Number(bValue)
    } else {
      result = String(aValue).localeCompare(String(bValue))
    }

    return isAsc ? result : -result
  })
}
